import { deepCopy } from '../../../../../utils/deepCopy';

// Normalizes `benchmarkFiltersAnalysis` (redux) into the `date` shape the
// benchmark visualization APIs expect: a custom range becomes { from, to },
// a preset keeps only `preset`, and `customDateRange` never goes over the
// wire. Shared by FilterSection (page-level fetch) and SampleComments
// (dropdown-driven scope re-fetch) so both send identical filters.
export const buildBenchmarkFiltersPayload = (benchmarkFiltersAnalysis) => {
    const payload = deepCopy({ ...benchmarkFiltersAnalysis });
    let date = payload.date;
    if (date.customDateRange.length > 0) {
        date = { ...date, to: date.customDateRange[1], from: date.customDateRange[0] };
        delete date.preset;
    }
    if (date.preset && date.preset !== "") {
        delete date.from;
        delete date.to;
    }
    else {
        delete date.preset;
    }
    delete date.customDateRange;
    payload.date = date;
    return payload;
};
